export class CurrencyConversionErrorResponse {
  localCurrencyScale: any;
  conversions: any;
}
